import React from 'react';
import { Box, Button, Stack } from '@mui/material';

const Carousel = ({ logos }) => {
    // Duplicate the cards for seamless looping
    const duplicateLogos = [...logos, ...logos];

    return (
        <Box
            sx={{
                width: { xl: "72%", lg: "80%", md: "89%", sm: "100%", xs: "92%" },
            }}>
            <Stack
                sx={{
                    overflow: 'hidden',
                    width: '100%',
                    position: 'relative',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        width: 'max-content',
                        animation: 'scroll 30s linear infinite',
                        gap: '20px',
                    }}

                >
                    {duplicateLogos.map((logo, index) => (
                        <img
                            key={index}
                            src={logo.img}
                            alt={`logo-${index}`}
                            style={{
                                height: "40px",
                                width: "100px",
                                color: "white",
                            }}
                        />
                    ))}
                </Box>
            </Stack>


            {/* CSS Keyframes */}
            <style>
                {`
          @keyframes scroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
        `}
            </style>
        </Box>
    );
};

export default Carousel;
